<template>
  <div class="notification"
    :class="{ desktopFeed: isDesktopFeed === true, latestBreaking: isSpecial === 'latestBreaking', wiim: isSpecial === 'wiim', rowNotification: isRow, newsNotification: type === 'news', breakingNews: (notification.isBreaking || notification.isbreaking || notification.tags?.includes('highlight')) && !isSpecial }">

    <div style="z-index: 1; cursor: pointer; position: absolute; left: 0; top: 0; width: 100%; height: 100%;"
      @click="openFeedWindow(isSpecial === 'latestBreaking' ? 'breaking' : 'wiim')" v-if="isSpecial" />

    <div class="notificationContent">
      <div class="narrowContent">
        <div class="symbols"
          v-if="notification.symbols.length > 0 && !isRow && (type !== 'news' || notification.tags.includes('price target'))">

          <div :key="symbol.symbol" class="symbolWrapper"
            v-for="(symbol, sIdx) in symbols.slice(0, !showMore ? (feedType === 'symbolPage' ? 1 : 2) : notification.symbols.length)"
            :class="{ inWatchlist: symbol.inWatchlist }">
            <SymbolLink :symbol="symbol.symbol" />
            <SymbolLabel :symbol="symbol" :dont-link="true" :show-pre-post="true" :small="true"
              :pre-market-quote="prices?.preMarketPrices?.[symbol.symbol]"
              :post-market-quote="prices?.postMarketPrices?.[symbol.symbol]" :prices="prices" />
          </div>

          <div v-if="notification.symbols.length > (feedType === 'symbolPage' ? 1 : 2)" class="moreSymbols"
            @click="showMore = !showMore">

            <span v-if="!showMore">
              <i class="ri-eye-line" /> {{
                notification.symbols.length - (feedType === 'symbolPage' ? 1 : 2)
              }} {{ dictionary.tags.moreSymbols }}
            </span>
            <span v-else>
              <i class="ri-eye-off-line" />
              {{ dictionary.tags.hideSymbols }}
            </span>

          </div>
        </div>

        <div class="notificationMessage">
          <div v-if="aggregate && !notification.hasContent && !hasLink() && notification.count > 0"
            @click="$emit('showAggregation')"
            style="position: absolute; left:0; top: 0; width: 100%; height: 100%; cursor: pointer"
            :key="notification.link" />

          <a :href="notification.link"
            v-if="!notification.hasContent && notification.link && notification.link.includes('http')"
            target="_blank" />
          <div v-else-if="notification.hasContent && !notification.metaData?.isTrade"
            @click="openReader(notification.link)"
            style="position: absolute; left:0; top: 0; width: 100%; height: 100%; cursor: pointer;"
            :key="notification.link" />
          <router-link v-else-if="notification.metaData?.isTrade" :to="`/trade/${notification.metaData.tradeId}`" />
          <p :style="shouldMarginBottom()"
            :class="{ latestBreakingText: isSpecial === 'latestBreaking', wii: isSpecial === 'wii', textRTL: notificationLang === 'he' }">

            <span class="classTag" :dir="uiDirection"
              v-if="(notification.sourceType === 'pr' || notification.categories?.includes('pr')) && notification.sourceName !== 'SEC'">
              <i class="ri-megaphone-line" />
            </span>

            <span class="classTag" :dir="uiDirection"
              v-if="notification.tags?.includes('insiders') && notification.tags?.includes('form-4')">
              <router-link v-if="notification.symbols[0]"
                :to="`/symbol/${notification.symbols[0].symbol}?tab=insiders`" />
              <i class="ri-briefcase-4-line" />
            </span>

            <span class="classTag" :dir="uiDirection" v-if="notification.tags?.includes('trading halt')">
              <router-link v-if="notification.symbols[0]" :to="`/symbol/${notification.symbols[0].symbol}`" />
              <i class="ri-stop-circle-line" />
            </span>

            <span class="classTag" :dir="uiDirection" v-if="notification.tags?.includes('trading resumption')">
              <router-link v-if="notification.symbols[0]" :to="`/symbol/${notification.symbols[0].symbol}`" />
              <i class="ri-play-circle-line" />
            </span>

            <span class="classTag" :dir="uiDirection" v-if="notification.tags?.includes('taReview')">
              <router-link v-if="notification.symbols[0]" :to="`/symbol/${notification.symbols[0].symbol}`" />
              <i class="ri-file-chart-line" />
            </span>

            <span class="classTag" :dir="uiDirection" v-if="notification.tags?.includes('trade')">
              <router-link v-if="notification.symbols[0]" :to="`/symbol/${notification.symbols[0].symbol}`" />
              <i class="ri-line-chart-line" /> {{ dictionary.tags.trade }} <short-long-label
                :direction="notification.metaData?.originalTrade?.direction" />
            </span>


            <span class="classTag" :dir="uiDirection" v-if="notification.tags?.includes('signal')">
              <router-link v-if="notification.symbols[0]" :to="`/symbol/${notification.symbols[0].symbol}`" />
              <i class="ri-stock-line" />
            </span>

            <span v-if="isSpecial" class="isSpecialTitle">
              <span style="display: block; font-size: 16px; font-weight: 600 !important;margin-bottom: 5px">
                <i class="ri-pushpin-fill" />
                {{ isSpecial === 'latestBreaking' ? dictionary.feeds.breakingNews : dictionary.feeds.wiim }}
              </span>
              <span class="isSpecialCounter" v-if="specialCount > 1" :key="specialCount">
                {{ specialCount }}
              </span>
            </span>


            <span v-if="!isCollapsed">
              <span v-if="!notification.tags?.includes('insiders')" :class="{ specialNotificationText: isSpecial }">{{
                text }}</span>

              <span v-else :style="innerNotificationStyle(notification.isInner)"><span
                  v-html="highlightTransaction(text)"></span></span>
              <span class="moreSymbols fullText" @click="showFullText = !showFullText"
                v-if="numberOfWords > wordsLimit && !isSpecial">
                {{ showFullText ? dictionary.buttons.readLess : dictionary.buttons.readMore }}
              </span>
            </span>

          </p>
        </div>
      </div>

      <image-thumbnail v-if="notification.file?.type === 'image'" :border="true"
        :base64="notification.file.mime === 'base64' ? notification.file.src : null"
        :image-name="notification.file.name" />


      <div class="followup" v-if="notification.metaData?.isFollowup && notification.metaData?.originalTrade">

        <div class="linkWrapper">
          <router-link :to="`/trade/${notification.metaData.tradeId}`" />
          <p class="followupLabel"><i class="ri-loop-left-line" /> {{ dictionary.messages.followup }}
            (<span :class="{ up: priceChange > 0, down: priceChange < 0 }" class="changeLabel">{{ priceChange }}% {{
              dictionary.trades.since
            }}</span>),<small>{{ dictionary.trades.published }} @ {{
                formatDateTime(notification.metaData.originalTrade.datetime)
              }}</small>:</p>
          <p class="followupOriginal" :class="{ textRTL: notificationLang === 'he' }">{{ originalTradeText }}</p>
        </div>


        <!--      <image-thumbnail v-if="notification.metaData?.originalTrade?.file?.type === 'image'" :border="true"-->
        <!--                       :base64="notification.metaData.originalTrade.file.mime === 'base64' ? notification.metaData.originalTrade.file.src : null"-->
        <!--                       :image-name="notification.metaData.originalTrade.file.name"/>-->


      </div>


      <div style="display: flex; align-items: center; justify-content: space-between" v-if="!isCollapsed">
        <NotificationDetails @translate="originalLanguage = !originalLanguage"
          @showAggregation="$emit('showAggregation')" :feed-type="type" :originalLanguage="originalLanguage"
          :isSpecial="isSpecial" :aggregate="aggregate" :count="notification.count" :isRow="isRow"
          :notification="notification" />

        <!--                <i v-if="showBreakingIcon && (notification.isBreaking || notification.isbreaking)" :dir="uiDirection"-->
        <!--                   class="ri-fire-line breakingIcon"/>-->
      </div>


      <div v-if="notification.metaData && notification.metaData.bullets && notification.tags.includes('form-4')"
        class="bullets">

        <div class="shouldKnow" @click="showShouldKnow = !showShouldKnow; toggleShouldKnow()">

          <div>
            <i class="ri-lightbulb-line" />
            {{ dictionary.tags.shouldKnowNotificationTitle }} (BETA)
          </div>

          <div class="shouldKnowToggle" v-if="!showShouldKnow">
            {{ dictionary.buttons.showMoreInfo }}
            <i class="ri-arrow-down-s-line" />
          </div>

          <div class="shouldKnowToggle" v-if="showShouldKnow">
            {{ dictionary.buttons.hideMoreInfo }}
            <i class="ri-arrow-up-s-line" />
          </div>
        </div>

        <div class="shouldKnowWrapper" ref="shouldKnowWrapper">
          <div class="bullet" v-for="bullet in notification.metaData.bullets" :key="bullet.text.en">
            <span style="font-size: 20px; margin-top: -4px;">&bull;</span> {{ bullet?.text[systemLanguage] }}
            <!--        <i class="ri-check-line"/> {{bullet?.text[systemLanguage]}}-->
          </div>
        </div>
      </div>

      <div class="notificationTags" v-if="!isSymbolPage && notification.events?.length > 0 && !this.isRow && this.type !== 'news'"
        :key="notification.events.length">
        <div class="eventRow">
          <div class="tag event" v-for="event in eventsList"
            :class="{ past: event.event.daysDiff === -1, today: event.event.daysDiff === 0, dark: systemTheme === 'darkMode' }"
            :key="'ev' + event.symbol">
            <i class="ri-calendar-line" />
            {{ event.symbol }} {{ event.event.label }}
          </div>
        </div>


        <div v-if="notification.events.length > 1" class="moreSymbols" @click="showMoreEvents = !showMoreEvents"
          :key="notification.events.length">
          <span v-if="!showMoreEvents">
            <i class="ri-eye-line" /> {{ notification.events.length - 1 }} {{ dictionary.tags.moreEvents }}
          </span>
          <span v-else>
            <i class="ri-eye-off-line" />
            {{ dictionary.tags.hideSymbols }}
          </span>
        </div>

      </div>
    </div>


  </div>
</template>

<script>

import { useEquityPrices } from "../../../stores/equityPrices";
import SymbolLabel from "../../symbols/symbol";
import NotificationDetails from "./NotificationDetails";


import extraEventData from "../../../composables/eventTagExtraData";
import ImageOverlay from "../../ui/ImageOverlay";
import ImageThumbnail from "../../ui/imageThumbnail";
import { DateTime } from "luxon";
import ShortLongLabel from "../../ui/ShortLongLabel";
import SymbolLink from "../../symbols/symbolLink";
import eventBus from '../../../services/events';

export default {
  name: "Notification",
  components: { SymbolLink, ShortLongLabel, ImageThumbnail, ImageOverlay, NotificationDetails, SymbolLabel },
  props: ['notification', 'isRow', 'type', 'feedType', 'hideEventsBySymbols', 'isSpecial', 'showBreakingIcon', 'isCollapsed', 'specialCount', 'aggregate', 'isDesktopFeed', 'isSymbolPage'],
  setup() {


    const prices = useEquityPrices();
    return { prices, extraEventData };
  },
  created() {

    this.numberOfWords = this.notification.title ? this.notification.title?.split(/[ ]/g).length : 10;
  },
  data() {
    return {
      showImage: false,
      showShouldKnow: false,
      notificationLang: this.systemLanguage,
      divToolTipOn: false,
      originalLanguage: false,
      showMore: false,
      showMoreEvents: false,
      wordsLimit: 20,
      showFullText: false,
      numberOfWords: 1
    }
  },
  computed: {
    eventsList() {


      if (this.showMoreEvents || this.notification.events.length < 2) {
        return this.notification.events;
      } else {
        return [this.notification.events[0]]
      }
    },
    priceChange() {

      if (this.notification.tags.includes('followup')) {
        const initPrice = this.notification.metaData?.originalTrade?.priceOnInit ?? null;
        if (initPrice === null) return null;

        const currentPrice = this.prices?.prices[this.notification.symbols[0].symbol]?.price;
        return parseFloat(((currentPrice - initPrice) / initPrice).toFixed(2)) * 100
      } else {
        return null
      }
    },
    symbols() {

      try {
        const watchlist = this.globalWatchlist.watchlist;
        let inWatchlistSymbol = this.notification.symbols.filter(symbol => watchlist.includes(symbol.symbol));
        let notInWatchlistSymbol = this.notification.symbols.filter(symbol => !watchlist.includes(symbol.symbol));

        if (notInWatchlistSymbol.length > 0) {

          inWatchlistSymbol = inWatchlistSymbol.map(symbol => {

            symbol.inWatchlist = true;
            return symbol;
          });
        }

        if (this.feedType === 'symbolPage') {

          let currentSymbol = this.notification.symbols.filter(symbol => symbol.symbol === this.$route.params.symbol);
          let symbolsList = [...currentSymbol, ...inWatchlistSymbol.filter(symbol => symbol.symbol !== this.$route.params.symbol), ...notInWatchlistSymbol.filter(symbol => symbol.symbol !== this.$route.params.symbol)];
          return symbolsList.map(symbol => {

            symbol.inWatchlist = watchlist.includes(symbol.symbol);
            return symbol;
          })
        }
        return [...inWatchlistSymbol, ...notInWatchlistSymbol];
      } catch (e) {
        return this.notification.symbols;
      }
    },
    events() {

      if (this.hideEventsBySymbols) {

        this.notification.events = this.notification.events.filter(event => !this.hideEventsBySymbols.includes(event.symbol))
      }
      return this.notification.events.slice(0, this.showMoreEvents ? this.notification.events.length : 2);
    },
    originalTradeText() {
      let text = null;

      if (!this.notification.metaData?.originalTrade) return '';

      if (!this.originalLanguage) {

        let notificationLanguage = this.systemLanguage === 'en' ? 'en' : 'he';
        this.notificationLang = notificationLanguage;
        text = this.notification.metaData.originalTrade.languages && this.notification.metaData.originalTrade.languages[notificationLanguage] ? this.notification.metaData.originalTrade.languages[notificationLanguage] : this.notification.metaData.originalTrade.title;
      } else {

        let notificationLanguage = this.systemLanguage === 'en' ? 'he' : 'en';
        this.notificationLang = notificationLanguage;
        text = this.notification.metaData.originalTrade.languages && this.notification.metaData.originalTrade.languages[notificationLanguage] ? this.notification.metaData.originalTrade.languages[notificationLanguage] : this.notification.metaData.originalTrade.title;
      }


      return text;
    },
    text() {

      let text = null;

      if (!this.originalLanguage) {

        let notificationLanguage = this.systemLanguage === 'en' ? 'en' : 'he';
        this.notificationLang = notificationLanguage;
        // if (this.systemLanguage === 'en') return this.notification.title;
        text = this.notification.languages && this.notification.languages[notificationLanguage] ? this.notification.languages[notificationLanguage] : this.notification.title;
      } else {

        let notificationLanguage = this.systemLanguage === 'en' ? 'he' : 'en';
        this.notificationLang = notificationLanguage;
        text = this.notification.languages && this.notification.languages[notificationLanguage] ? this.notification.languages[notificationLanguage] : this.notification.title;
      }


      if (text) {
        let splitText = text.split(/[ ]/g);

        return (splitText.length > this.wordsLimit && !this.showFullText) ? splitText.slice(0, this.wordsLimit).join(' ') + '...' : text;
      } else {
        return text;
      }
    }
  },
  methods: {
    hasLink() {
      return this.notification.link?.includes('http')
    },
    innerNotificationStyle(isInner) {
      return isInner ? { height: '30px', display: 'inline-flex' } : {}
    },
    openFeedWindow(feedName) {

      eventBus.emit('openFeedWindow', feedName);
      this.$emit('showBreaking');
    },
    openReader(link) {
      eventBus.emit('readNotification', link)
    },
    highlightTransaction(text) {
      const regex = /\b(sold|bought|buy)\s([\d,]+)\sshares|\b(מכירה|קניה)\s([\d,]+)\sניירות/gi;

      return text.replace(regex, (match, engAction, engAmount, hebAction, hebAmount) => {
        let color;
        if (engAction) {
          color = engAction.toLowerCase() === 'sold' ? 'var(--red)' : 'var(--green)';
          return `<span style="color: ${color}; font-weight: bold;">${engAction} ${engAmount} shares</span>`;
        } else if (hebAction) {
          color = hebAction === 'מכירה' ? 'var(--red)' : 'var(--green)';
          return `<span style="color: ${color}; font-weight: bold;">${hebAction} ${hebAmount} ניירות</span>`;
        }

        return match; // fallback
      });
    },
    formatDateTime(datetime) {

      return DateTime.fromISO(datetime).setLocale(this.dateFormatLocale).toFormat('DDD')
    },
    toggleShouldKnow() {
      if (this.showShouldKnow) {
        this.$refs.shouldKnowWrapper.style.height = `${this.$refs.shouldKnowWrapper.scrollHeight}px`
      } else {
        this.$refs.shouldKnowWrapper.style.height = '0px';
      }
    },
    shouldMarginBottom() {
      return this.isRow ? { marginBottom: 0 } : {}
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/style/vars";
@import "../../../assets/style/notification";

.textRTL {
  direction: rtl;
  width: 100%;
  //unicode-bidi: plaintext;
  text-align: right;
}

.latestBreaking {
  position: relative;
  background: linear-gradient(200deg, rgba(0, 0, 0, 0) 0%, rgba(201, 1, 31, 0.55) 300%);
  margin: 5px;
  border-bottom: 0;
  border-radius: 8px;

  p {}
}


.wiim {
  position: relative;
  background: linear-gradient(200deg, rgba(0, 0, 0, 0) 0%, rgba(139, 92, 246, 0.6) 300%);
  margin: 5px;
  border-bottom: 0;
  border-radius: 8px;

  p {}
}

.bullets {
  margin-top: 20px;

  .shouldKnowWrapper {
    overflow: hidden;
    height: 0;
    transition: $toggleTransition;
  }

  .shouldKnow {
    cursor: pointer;
    background: var(--lightYellowOpacity);
    color: var(--lightYellow);
    padding: 5px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .shouldKnowToggle {
      i {
        font-size: 22px;
      }

      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  .bullet {

    i {
      margin-top: 2px;
    }

    display: flex;
    align-items: flex-start;
    gap: 5px;
    padding: 5px 0;
    font-size: 14px;
  }
}

[data-theme="light"] {
  .symbolWrapper {
    background: rgba(0, 0, 0, .05);
    color: var(--textColor);
  }

  .breakingNews {}
}

.symbolWrapper {
  position: relative;
  background: rgba(137, 137, 137, 0.12);
  border-radius: 4px;
  padding: 0 1px;

  a {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.latestBreakingText {
  color: var(--red) !important;
}

.isSpecialTitle {
  display: flex;
  align-items: flex-start;
  gap: 15px;

  .isSpecialCounter {
    background: var(--afterMarketColorOpacity);
    padding: 0 10px;
    border-radius: 4px;
    color: var(--textColor);
    box-shadow: 0 4px 5px 0 rgba(255, 255, 255, .1);
  }
}

.specialNotificationText {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 350px;
  font-size: 16px;
}
</style>
